import { FormattedMessage, FormattedNumber } from "react-intl";
import { ActivityIndicator } from "react-native";
import Text from "@ticketingplatform/ui/dist/components/styles/Typography";
import Button from "@ticketingplatform/ui/dist/components/atoms/Button";
import { useEventOccurrence } from "views/EventDetails/hooks";
import { Card, Flex } from "components/styles";
import useOrderSession from "hooks/useOrderSession";
import OrderSessionButton from "components/atoms/OrderSessionButton";
import environment from "setup/environment";
import EventHeading from "views/EventDetails/partials/EventHeading";

import * as Styled from "./styles";
import { usePayment } from "./hooks";

const Payment: React.FC = () => {
  const { eventOccurrence, loading } = useEventOccurrence(true);
  const { expireAt, expireIn, isExpired, onReset } = useOrderSession();
  const {
    total,
    paymentType,
    error,
    loading: paymentLoading,
    pay,
  } = usePayment();

  if (loading) {
    return <ActivityIndicator />;
  }

  if (!eventOccurrence) {
    return (
      <Text textAlign="center" margin="2rem">
        <FormattedMessage defaultMessage="Event not found" />
      </Text>
    );
  }

  return (
    <Flex padding="0.5rem" flexDirection="column" height="100%" overflow="auto">
      <EventHeading {...eventOccurrence} />
      <Card>
        <Styled.Heading>
          <FormattedMessage
            defaultMessage="Confirm {paymentType}"
            values={{ paymentType }}
          />
        </Styled.Heading>
        <Styled.Total>
          <FormattedNumber
            style="currency"
            currency={environment.CURRENCY}
            value={total}
          />
        </Styled.Total>
        <Styled.Actions>
          <Button
            $fullW
            type="button"
            $mode="tertiary"
            size="large"
            disabled={isExpired || paymentLoading}
            onClick={pay}
          >
            <FormattedMessage defaultMessage="Confirm" />
          </Button>
          {expireAt && (
            <OrderSessionButton
              {...{
                expireIn,
                isExpired,
                onReset,
              }}
            />
          )}
          {error && <Styled.Error>{error}</Styled.Error>}
        </Styled.Actions>
      </Card>
    </Flex>
  );
};

export default Payment;
